/* Gentle Journeys - a visible way to see and move through the home reviews (15 Oct 2026).
   Judge.me's cards carousel hides its arrows on a phone and gives no sign there is a second review.
   This adds "1 / 2", two 44px arrows and a "Swipe for more" line under it, only when the cards do not all fit.
   It moves the carousel with Judge.me's own functions, so swiping, the lightbox and the data are all theirs. */
(function () {
  function arrow(dir) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
  }
  function real(c) {
    return Array.prototype.filter.call(c.querySelectorAll('.jdgm-media-card'), function (e) {
      return !e.classList.contains('jdgm-clone-before') && !e.classList.contains('jdgm-clone-after');
    });
  }
  function build(c) {
    if (c.getAttribute('data-gj-rv')) return true;
    var wrap = c.querySelector('.jdgm-cards-wrapper');
    var cards = real(c);
    if (!wrap || cards.length < 2) return false;
    c.setAttribute('data-gj-rv', '1');
    var id = c.getAttribute('data-jdgm-block-id');
    var ui = document.createElement('div');
    ui.className = 'gj-rv-ctl';
    ui.innerHTML =
      '<div class="gj-rv-row">' +
      '<button type="button" class="gj-rv-btn" aria-label="Previous review">' + arrow(-1) + '</button>' +
      '<span class="gj-rv-count" aria-live="polite"></span>' +
      '<button type="button" class="gj-rv-btn" aria-label="Next review">' + arrow(1) + '</button></div>' +
      '<p class="gj-rv-swipe">Swipe for more <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></p>';
    c.appendChild(ui);
    var count = ui.querySelector('.gj-rv-count');
    var btns = ui.querySelectorAll('.gj-rv-btn');
    function moved() { ui.classList.add('gj-rv-moved'); }
    btns[0].addEventListener('click', function () { moved(); if (window.jdgmPreviousCard) window.jdgmPreviousCard(id); });
    btns[1].addEventListener('click', function () { moved(); if (window.jdgmNextCard) window.jdgmNextCard(id); });
    function update() {
      var list = real(c), n = list.length, at = 0;
      list.forEach(function (e, i) { if (e.classList.contains('active')) at = i; });
      count.textContent = (at + 1) + ' / ' + n;
      // does every card fit in the window? then there is nothing to scroll to: hide the controls
      var w = list[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(c).getPropertyValue('--jm-card-gap')) || 14;
      ui.hidden = (n * w + (n - 1) * gap) <= wrap.clientWidth + 1;
      list.forEach(function (e) {
        var p = e.querySelector('.jdgm-text p');
        e.classList.toggle('gj-rv-cut', !!p && p.scrollHeight > p.clientHeight + 2);
      });
    }
    var last = -1;
    new MutationObserver(function () {
      var at = real(c).findIndex(function (e) { return e.classList.contains('active'); });
      if (last !== -1 && at !== last) moved();
      last = at;
      update();
    }).observe(c, { subtree: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(c);
    update();
    return true;
  }
  function scan() {
    var list = document.querySelectorAll('.jdgm-cards-carousel');
    var all = list.length > 0;
    Array.prototype.forEach.call(list, function (c) { if (!build(c)) all = false; });
    return all;
  }
  var tries = 0;
  var t = setInterval(function () { if (scan() || ++tries > 50) clearInterval(t); }, 300);
})();
